var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMemo } from 'react';
import { useGetMembersCapabilities } from '#query-hooks';
export const useMembersLimit = (workspaceId) => {
    _react_refresh_temp_1();
    const { query: { data: billingData }, } = useGetMembersCapabilities({ workspaceId: workspaceId || '' });
    const availableSlots = useMemo(() => {
        if (billingData?.capabilities.members.max) {
            return (billingData.capabilities.members.max -
                billingData.capabilities.members.current -
                billingData.capabilities.members.pending);
        }
        return null;
    }, [billingData]);
    return {
        availableSlots,
        maxMembers: billingData?.capabilities.members.max,
    };
};
_react_refresh_temp_1(useMembersLimit, "8guWoG8QC2fkTJGHXKCx5f/CoeA=", false, () => [useGetMembersCapabilities]);
